<template>
  <div class="oss-file-mgmt">
    <div class="breadcrumb-box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>文件管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="section-card">
      <div class="section-title">查询条件</div>
      <div class="header-line">
        <span class="header-label">业务模块</span>
        <el-input v-model="filterBizModule" size="small" clearable placeholder="精确匹配" style="width: 180px" />
        <template v-if="isSuperAdmin">
          <span class="header-label">上传人 ID</span>
          <el-input v-model="filterOperateUserId" size="small" clearable placeholder="仅超级管理员" style="width: 160px" />
        </template>
        <el-button type="primary" size="small" @click="onQueryClick">查询</el-button>
        <el-button type="success" size="small" icon="el-icon-upload2" @click="openUploadDialog">上传</el-button>
      </div>
    </div>

    <div class="main-box">
      <el-table :data="tableData" border stripe size="small" :height="screenHeight" style="width: 100%">
        <el-table-column prop="id" label="ID" width="72" align="center" />
        <el-table-column prop="originalFileName" label="原始文件名" min-width="140" show-overflow-tooltip />
        <el-table-column prop="bizModule" label="业务模块" width="120" show-overflow-tooltip />
        <el-table-column label="大小" width="100" align="right">
          <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
        </el-table-column>
        <el-table-column prop="operateUserId" label="上传人" width="100" align="center" />
        <el-table-column label="上传时间" width="170">
          <template slot-scope="scope">{{ formatTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column prop="fileUrl" label="完整URL" min-width="280" show-overflow-tooltip />
        <el-table-column label="下载" width="90" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="onDownload(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="objectKey" label="ObjectKey" min-width="200" show-overflow-tooltip />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" style="color: #f56c6c" @click="onDeleteRow(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pager-wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[10, 20, 50, 100]"
          :current-page.sync="currentPage"
          :page-size.sync="pageSize"
          :total="totalRecords"
          @size-change="onPageSizeChange"
          @current-change="loadList"
        />
      </div>
    </div>

    <el-dialog
      title="上传到 OSS"
      :visible.sync="uploadDialogVisible"
      width="520px"
      :close-on-click-modal="false"
    >
      <el-form label-width="90px" size="small">
        <el-form-item label="业务模块">
          <el-input v-model="uploadBizModule" clearable placeholder="可选，写入记录的 bizModule" />
        </el-form-item>
        <el-form-item label="单文件上传">
          <el-upload
            ref="uploader"
            action=""
            :auto-upload="false"
            :limit="1"
            :on-change="onFileChange"
            :on-remove="onFileRemove"
            :file-list="uploadFileList"
          >
            <el-button size="small">选取文件</el-button>
          </el-upload>
          <el-button type="primary" size="small" :loading="uploading" @click="onUploadSubmit" style="margin-left: 10px">上传</el-button>
        </el-form-item>
        <el-form-item label="批量上传">
          <div>
            <el-upload
              ref="batchUploader"
              action=""
              :auto-upload="false"
              multiple
              :limit="50"
              :on-exceed="onBatchExceed"
              :on-change="onBatchFileChange"
              :on-remove="onBatchFileRemove"
              :file-list="batchFileList"
            >
              <el-button size="small">选取多个文件</el-button>
            </el-upload>
            <el-button type="primary" size="small" :loading="batchUploading" @click="onBatchUploadSubmit" style="margin-left: 10px">批量上传</el-button>
            <div class="upload-hint">最多 50 个，单文件失败不影响其余文件</div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="uploadDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ossModules } from "@r";

export default {
  name: "OssFileMgmt",
  data() {
    return {
      uploadBizModule: "",
      uploadDialogVisible: false,
      uploadFileList: [],
      currentFile: null,
      uploading: false,
      batchFileList: [],
      batchUploading: false,
      filterBizModule: "",
      filterOperateUserId: "",
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      screenHeight: document.body.clientHeight - 64 - 200 - 120,
    };
  },
  computed: {
    roles() {
      const userState = this.$store.state.user;
      return (userState && Array.isArray(userState.roles)) ? userState.roles : [];
    },
    isSuperAdmin() {
      return this.roles.includes("admin");
    },
  },
  activated() {
    this.loadList();
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 200 - 120;
    },
    formatTime(ts) {
      if (ts == null || ts === "") {
        return "—";
      }
      const d = new Date(Number(ts));
      if (isNaN(d.getTime())) {
        return "—";
      }
      const pad = n => (n < 10 ? "0" + n : "" + n);
      return (
        d.getFullYear() +
        "-" +
        pad(d.getMonth() + 1) +
        "-" +
        pad(d.getDate()) +
        " " +
        pad(d.getHours()) +
        ":" +
        pad(d.getMinutes()) +
        ":" +
        pad(d.getSeconds())
      );
    },
    formatFileSize(bytes) {
      if (bytes == null || bytes === "") {
        return "—";
      }
      const n = Number(bytes);
      if (isNaN(n) || n < 0) {
        return "—";
      }
      if (n < 1024) {
        return n + " B";
      }
      if (n < 1024 * 1024) {
        return (n / 1024).toFixed(1) + " KB";
      }
      return (n / 1024 / 1024).toFixed(2) + " MB";
    },
    onFileChange(file, fileList) {
      this.currentFile = file.raw;
      this.uploadFileList = fileList.slice(-1);
    },
    onFileRemove() {
      this.currentFile = null;
      this.uploadFileList = [];
    },
    onBatchExceed() {
      this.$message.warning("单次最多选择 50 个文件");
    },
    onBatchFileChange(file, fileList) {
      this.batchFileList = fileList;
    },
    onBatchFileRemove(file, fileList) {
      this.batchFileList = fileList;
    },
    onBatchUploadSubmit() {
      if (!this.batchFileList || this.batchFileList.length === 0) {
        this.$message.warning("请先选择至少一个文件");
        return;
      }
      const fd = new FormData();
      let n = 0;
      this.batchFileList.forEach(item => {
        if (item.raw) {
          fd.append("files", item.raw);
          n++;
        }
      });
      const bm = (this.uploadBizModule || "").trim();
      if (bm) {
        fd.append("bizModule", bm);
      }
      if (n === 0) {
        this.$message.warning("没有有效的本地文件");
        return;
      }
      this.batchUploading = true;
      ossModules
        .uploadBatch(fd)
        .then(res => {
          this.batchUploading = false;
          const fails = (res.mdata && res.mdata.batchFailures) || [];
          if (res.result !== 1) {
            this.showBatchFailures(fails, res.message || "批量上传失败");
            return;
          }
          const okCount = (res.ldata && res.ldata.length) || 0;
          if (fails.length) {
            this.$message.warning(res.message || `成功 ${okCount} 个，部分失败`);
            this.showBatchFailures(fails, "以下为上传失败文件");
          } else {
            this.$message.success(res.message || `上传成功 ${okCount} 个文件`);
            this.uploadDialogVisible = false;
          }
          this.batchFileList = [];
          if (this.$refs.batchUploader) {
            this.$refs.batchUploader.clearFiles();
          }
          this.currentPage = 1;
          this.loadList();
        })
        .catch(err => {
          this.batchUploading = false;
          const fails = (err && err.mdata && err.mdata.batchFailures) || [];
          if (fails.length) {
            this.showBatchFailures(fails, err.message || "全部失败");
          } else {
            this.$message.error((err && err.message) || "批量上传失败");
          }
        });
    },
    showBatchFailures(fails, title) {
      if (!fails.length) {
        return;
      }
      const text = fails.map(f => (f.fileName || "") + "：" + (f.message || "")).join("\n");
      this.$alert(text, title || "失败明细", { confirmButtonText: "确定", customClass: "oss-batch-fail-alert" });
    },
    openUploadDialog() {
      this.uploadDialogVisible = true;
    },
    onUploadSubmit() {
      if (!this.currentFile) {
        this.$message.warning("请先选择文件");
        return;
      }
      const fd = new FormData();
      fd.append("file", this.currentFile);
      const bm = (this.uploadBizModule || "").trim();
      if (bm) {
        fd.append("bizModule", bm);
      }
      this.uploading = true;
      ossModules
        .upload(fd)
        .then(res => {
          this.uploading = false;
          if (res.result !== 1) {
            this.$message.error(res.message || "上传失败");
            return;
          }
          this.$message.success("上传成功");
          this.uploadDialogVisible = false;
          this.uploadBizModule = "";
          this.uploadFileList = [];
          this.currentFile = null;
          if (this.$refs.uploader) {
            this.$refs.uploader.clearFiles();
          }
          this.currentPage = 1;
          this.loadList();
        })
        .catch(err => {
          this.uploading = false;
          this.$message.error((err && err.message) || "上传失败");
        });
    },
    onQueryClick() {
      this.currentPage = 1;
      this.loadList();
    },
    onPageSizeChange() {
      this.currentPage = 1;
      this.loadList();
    },
    loadList() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
      };
      const fb = (this.filterBizModule || "").trim();
      if (fb) {
        params.bizModule = fb;
      }
      if (this.isSuperAdmin) {
        const oid = (this.filterOperateUserId || "").trim();
        if (oid !== "" && !isNaN(Number(oid))) {
          params.operateUserId = Number(oid);
        }
      }
      ossModules
        .page(params)
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "查询失败");
            return;
          }
          this.tableData = res.ldata || [];
          const md = res.mdata || {};
          this.totalRecords = md.totalRecords != null ? Number(md.totalRecords) : 0;
        })
        .catch(err => {
          this.$message.error((err && err.message) || "查询失败");
        });
    },
    onDownload(row) {
      if (!row || row.id == null) {
        return;
      }
      window.location.href = "/biz/oss/download?id=" + row.id;
    },
    onDeleteRow(row) {
      this.$confirm("确认删除该文件？将同时删除 OSS 对象且不可恢复。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return ossModules.delete(row.id);
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "删除失败");
            return;
          }
          this.$message.success("删除成功");
          this.loadList();
        })
        .catch(e => {
          if (e === "cancel") {
            return;
          }
          const msg = (e && (e.message || e.msg)) || (typeof e === "string" ? e : "删除失败");
          this.$message.error(msg);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.oss-file-mgmt {
  margin: 0 auto;
  background: #f5f7fa;
  min-height: calc(100vh - 64px);
  padding-bottom: 24px;
}
.breadcrumb-box {
  padding: 16px 20px 0;
  .el-breadcrumb {
    margin-bottom: 8px;
  }
}
.section-card {
  margin: 0 20px 12px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 12px;
}
.upload-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}
.header-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  .header-label {
    font-size: 13px;
    color: #606266;
  }
}
.main-box {
  margin: 0 20px;
  padding: 16px 20px 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.pager-wrap {
  margin-top: 16px;
  text-align: right;
}
</style>

<style lang="scss">
.oss-batch-fail-alert .el-message-box__message {
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 360px;
  overflow-y: auto;
}
</style>
